export default __webpack_public_path__ + "static/images/list-3.52ddc718.jpg";